import { Drawing } from "./index";

export const all = rect(0, Drawing.side * Drawing.side - 1);

export function rect(corner1: number, corner2: number): number[] {
  let topCorner = Math.min(corner1, corner2);
  topCorner = Math.max(topCorner, 0);
  let bottomCorner = Math.max(corner1, corner2);
  bottomCorner = Math.min(bottomCorner, Drawing.side * Drawing.side - 1);

  const width = Math.abs(
    (bottomCorner % Drawing.side) - (topCorner % Drawing.side)
  );
  const height = Math.abs(
    Math.floor(bottomCorner / Drawing.side) -
      Math.floor(topCorner / Drawing.side)
  );

  const topLeftCorner =
    bottomCorner - Drawing.side * height > topCorner
      ? topCorner
      : topCorner - width;

  const idxs = [];
  for (let row = 0; row <= height; row++) {
    for (let col = 0; col <= width; col++) {
      idxs.push(topLeftCorner + row * Drawing.side + col);
    }
  }
  return idxs;
}
